import Api from "./Api";
import * as XLSX from 'xlsx';
import Helper from "./Helper";
import axios from "axios";
import { getNewValue } from "../components/grid/ag/commonFunctions/GridCommonFunctions";
import Settings from "./Settings";

export const isRFQExpired = (expiry_datetime) => { 
  if(expiry_datetime === '' || !expiry_datetime || expiry_datetime === null) {
    return false;
  };
  
  const expiryDate = new Date(expiry_datetime);
  const currentDate = new Date();

  return currentDate > expiryDate;
};

export const ValidateData = (Data) => {
    const found = Object.values(Data).every(value => {
        if (value === null || value === "" || value === undefined) {
            return true;
        }else {       
        return false;  
}})
    return found;
};

export const handleFetchData = (response, totalRecords) => {
  totalRecords.current = response?.data?.total_records;
  return {
    rowData: response?.data?.data?.map((item) => ({
      ...item,
      gridId: `${Date.now()}_${getNewValue()}`,
    })),
    rowCount: response?.data?.total_records
  }
}

export const formatJson = (jsonString) => {
  try {
    const jsonObject = JSON.parse(jsonString);
    return JSON.stringify(jsonObject, null, 2);
  } catch (e) {
    return jsonString;
  }
};

export const exportToXlsx = async ({
  url,
  columns,
  fileName,
  additionalFunction,
  apiTokenRequired = true,
  customDataArray = []
}) => {
  const api = Api;
  api.setUserToken();

  try {
    let data;
 
    if (!checkIfArrayIsEmpty(customDataArray)) {
      data = customDataArray;
    } else if (url) {
      const response = api.axios().get(url)
        
      const status = response.data.status || response.status === 200 || response.data.success || response.data.Status;

      if (status !== 'success' && status !== 200 && status !== 'Success' && status !== true) {
        return;
      }

      data = response?.data?.data ?? response?.data?.results ?? [];
    } else {
      return;
    }
 
    if (!!additionalFunction) {
      data = additionalFunction(data);
    }
 
    const filteredColumns = columns.filter(col => col.field !== 'image');
    const headers = filteredColumns.map(col => col.headerName);
    const rows = data.map(row =>
      filteredColumns.map(col => row[col.field] ?? '')
    );

    const worksheetData = [headers, ...rows];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    worksheet['!cols'] = headers.map(header => ({ wch: header.length + 5 }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, fileName ?? 'Data');
    XLSX.writeFile(workbook, `${fileName ?? 'details'}.xlsx`);
  } catch (error) {
    console.error('Error during export:', error);
  }
};
 
export const checkIfArrayIsEmpty = (arr) => {
    if (Array.isArray(arr)) {
      return arr.length === 0;
    }
    return false;
}

export const checkObjectProperties = (obj) => {
    for (const prop in obj) {
      if (obj[prop] !== null) {
        return true;
      }
    }
    return false;
}

export const isEmptyObject = (obj) => {
    if (obj === null || obj === undefined) {
      return true;
    }
    return Object.keys(obj).length === 0;
};

export const checkIdsInObject = (obj, ids) => {
  return obj ? ids.every(id => obj.hasOwnProperty(id)) : false;
};

export const buildApiUrlForDropdown = (rawEndpoint = '') => {
  if (!rawEndpoint.startsWith('/')) return '';

  const [, firstSegment, ...rest] = rawEndpoint.split('/');

  const baseMap = {
    common: Settings.apiUrl,
    vendor: Settings.apiVendorUrl,
    items: Settings.apiItemUrl,
    po: Settings.apiPurchaseOrderUrl,
    org: Settings.apiOrgUrl,
    pr: Settings.apiPurchaseRequisitionUrl
  };

  const base = baseMap[firstSegment];
  if (!base) throw new Error(`Unknown API segment: ${firstSegment}`);

  return base + '/' + rest.join('/');
};

export const commonThousandSeparator = (input) => {
  if (input === null || input === undefined) return '-';

  const str = String(input).trim();
  const isNumeric = /^-?\d+(\.\d+)?$/.test(str);

  if (!isNumeric) return input;

  const number = Number(str);

  return number
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const validateWhereRulesWorkflowConditions = (existingConditions, rowData, isUpdate = false) => {
  const clause = (rowData.clause); 
 
  if (!isUpdate && existingConditions.length === 0 && clause != '1') {
    Helper.alert("Can't add AND/OR clause at the start of condition", 'error');
    return false;
  };
 
  return true;
};

export const getPopupMessageBasedOnStatus = (res) => {
    if (!res) return;
  
    if (res?.response?.status >= 500) {
      const errorMessage = res.response?.data?.message?.toLowerCase();
  
      if (errorMessage && errorMessage.includes('already exist')) {
        Helper.alert("This record is already exist.", 'error');
      } else {
        Helper.alert("Apologies, something went wrong from our side.", 'error');
      }
    } else {
      const message = res.response?.data?.message || 'An unexpected error occurred.';
      Helper.alert(message, 'error');
    }
}; 

export const checkObjectResponseCodes = (obj) => {
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const value = obj[key];
      if (value !== null && value === 500) {
        return false;
      }
    }
    return true;
}

export const ValidateArray = (dataArray) => { 
    let found;
    dataArray.forEach(element => {
        Object.values(element).every(value => {
            if (value === null || value === "" || value === undefined) {
                found = true;
        }else {       
            found = false;  
    }}) 
}); 
return found
}

//checks for inputType, and onChange field data
export const VallidateFields = (fieldData, inputType) => {
   let validate = false;
   if(inputType === "string" || inputType === "text" ){
    if(fieldData !== '' || fieldData !== null){
        validate = true
    }
   }  
   if(inputType === "number" || inputType === "integer" ){
    if(fieldData !== '' || fieldData !== null){
        validate = true
    }
   }  
   return validate;

}

export const objectIsEmpty = (obj) => {
  if (!obj) {
    return true;
  } else if (Array.isArray(obj) || typeof obj === "string") {
    return obj.length === 0;
  } else if (typeof obj === "object") {
    return Object.keys(obj).length === 0;
  } else {
    return false;
  }
};